import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const LocationIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M9.99999 11.317C11.4359 11.317 12.6 10.1529 12.6 8.71697C12.6 7.28103 11.4359 6.11697 9.99999 6.11697C8.56405 6.11697 7.39999 7.28103 7.39999 8.71697C7.39999 10.1529 8.56405 11.317 9.99999 11.317Z"
        fill="none"
        strokeWidth="1.25"
      />
      <path
        d="M3.01669 7.20031C4.65836 -0.0163544 15.35 -0.00802091 16.9834 7.20865C17.9417 11.442 15.3084 15.0253 13 17.242C11.325 18.8586 8.67502 18.8586 6.99169 17.242C4.69169 15.0253 2.05836 11.4336 3.01669 7.20031Z"
        fill="none"

        strokeWidth="1.25"
      />
    </SvgIcon>
  )
}
